import { camelCase } from 'lodash';

import { EnumValue, EnumValueString } from 'contexts/EnumValuesContext';

type EnumOption = Pick<EnumValue, 'name'> & { value: EnumValue['value'] | string };

export const normalizeEnumValues = (input: Array<EnumOption>) =>
  input.map(({ name, value }) => ({
    label: name,
    value,
  }));

export const normalizeEnumValuesString = (input: Array<EnumValueString>) =>
  input.map(({ name, value }) => ({
    label: name,
    value,
  }));

export const normalizeMetaValues = (input?: Array<string> | null) =>
  (input ?? []).map(value => ({
    label: value,
    value,
  }));

export const normalizeJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const camelizeKeys = (obj: any) => {
  if (Array.isArray(obj)) {
    return obj.map(v => camelizeKeys(v));
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: camelizeKeys(obj[key]),
      }),
      {},
    );
  }
  return obj;
};

export const toLowerKeys = (obj: any) => {
  if (Array.isArray(obj)) {
    return obj.map(v => toLowerKeys(v));
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [key.toLowerCase()]: toLowerKeys(obj[key]),
      }),
      {},
    );
  }
  return obj;
};

export const arrayToObject = (array: FormMetaProperty[]) =>
  array.reduce((obj, item) => {
    obj[item.name] = item.value;
    return obj;
  }, {});

export const convertObjectToArray = obj =>
  Object.entries(obj).map(entry => ({ name: entry[0], value: entry[1] }));
